// extracted by extract-css-chunks-webpack-plugin
module.exports = {"topNews":"topNews-bzegcG-z","first_title":"first_title-3az8LFMb","second_title":"second_title-1RLxG4VF","children":"children-2WgPIMBx"};